//import 'bootstrap';
$(document).ready(() => {
  const logo = document.getElementById("logo");
  const header = document.getElementById("header");

  const hamb = document.querySelector("#hamb");
  const mainNav = document.querySelector("#main-nav");
  const overlay = document.querySelector("#overlay");
  const closeMenuBtn = document.querySelector("#close-menu");
  const searchBtn = document.querySelector("#search-btn");
  const closeSearchBtn = document.querySelector("#close-search-btn");
  const searchModal = document.querySelector("#search-modal");

  let headerTimeout,
    activeSubMenuHeight = 0;
  // mega menu functionality
  jQuery(function ($) {
    $("li.mega-menu-item").on("open_panel", function () {
      if(window.innerWidth <= 1023){
        return;
        }
      // console.log("Sub menu opened");
      const isPanelOpen = document.querySelector(
        "#mega-menu-primary_navigation li.mega-toggle-on"
      );
      if (isPanelOpen) {


        clearTimeout(headerTimeout);

        headerTimeout = setTimeout(() => activateHeader(), 100);
      }
    });
  });

  jQuery(function ($) {
    $("li.mega-menu-item").on("close_panel", function () {
      if(window.innerWidth <= 1023){
      return;
      }
      // console.log("Sub menu closed");

      const isPanelOpen = document.querySelector(
        "#mega-menu-primary_navigation li.mega-toggle-on"
      );
      if (!isPanelOpen) {
        activeSubMenuHeight = 0;
        clearTimeout(headerTimeout);
        headerTimeout = setTimeout(() => deactivateHeader(), 100);
      }
    });
  });

  function activateHeader() {
    console.log("activating header");
    header.querySelector(".bottom").classList.remove("bg-white");
    header.querySelector(".bottom").classList.add("bg-blue");
    logo.classList.remove("text-blue");
    logo.classList.add("text-white");

  }

  function deactivateHeader() {
    console.log("deactivating header");
    header.querySelector(".bottom").classList.remove("bg-blue");
    header.querySelector(".bottom").classList.add("bg-white");
    logo.classList.remove("text-white");
    logo.classList.add("text-blue");
  }
  // floating labels for gform inputs with top label
  $(
    "form .top_label .gfield .ginput_container input, form .top_label .gfield .ginput_container textarea"
  ).on("focus", function () {
    // console.log("focusing");
    $(this).parent().parent(".gfield").addClass("active");
  });

  $(
    "form .top_label .gfield .ginput_container input, form .top_label .gfield .ginput_container textarea"
  ).on("blur", function () {
    if ($(this).val().length == 0) {
      $(this).parent().parent(".gfield").removeClass("active");
    }
  });

  $(
    "form .top_label .gfield .ginput_container input, form .top_label .gfield .ginput_container textarea"
  ).each(function () {
    if ($(this).val().length > 0) {
      // console.log("adding class active to input", $(this).val());
      $(this).parent().parent(".gfield").addClass("active");
    }
  });

  hamb.addEventListener(
    "click",
    function (e) {
      e.stopPropagation();
      openMenu();
    },
    false
  );

  // closeMenuBtn.addEventListener(
  //   "click",
  //   function (e) {
  //     e.stopPropagation();
  //     closeMenu();
  //   },
  //   false
  // );

  searchBtn.addEventListener(
    "click",
    function (e) {
      e.stopPropagation();
      openSearch();
    },
    false
  );

  closeSearchBtn.addEventListener(
    "click",
    function (e) {
      e.stopPropagation();
      closeSearch();
    },
    false
  );

  // opens the search
  function openSearch() {
    // console.log("opensearch function");
    searchModal.classList.remove("hidden");
  }

  // closes the search
  function closeSearch() {
    searchModal.classList.add("hidden");
  }

  // opens main nav
  function openMenu() {
    // console.log("opening nav");
    mainNav.classList.remove("translate-x-full");
    overlay.classList.remove("hidden");
  }

  // closes main nav
  function closeMenu() {
    // console.log("closing nav");
    mainNav.classList.add("translate-x-full");
    overlay.classList.add("hidden");
  }

  // animate on scroll library
  AOS.init();

  var dropdowns = document.querySelectorAll(".dropdown");
  var viewportWidth = $(window).width();
  window.addEventListener("resize", function () {
    viewportWidth = $(window).width();
  });
  // console.log(viewportWidth);

  $("body").click(function () {
    //closeSearch();
    closeAllDropDowns();
  });

  $(window).scroll(function () {
    if (viewportWidth <= 1023) {
      // console.log("mobile scroll");
      return;
    } else {
      // console.log("desktop scroll");
      closeSearch();
      closeAllDropDowns();
    }
  });

  // $('#searchHolderDesktop button').click(function (e) {
  //     e.stopPropagation()
  //     openSearch();
  // });

  // $('#searchHolderDesktop form').click(function (e) {
  //     e.stopPropagation()
  //     //openSearch();
  // });

  // function openSearch() {
  //     $('#searchHolderDesktop').addClass('active')
  //     $('#searchHolderDesktop form input.search-field').focus()
  //     $('.topnav a, .topnav .pipe').each(function () {
  //         $(this).addClass('hidden')
  //     })
  // }

  // function closeSearch() {
  //     $('#searchHolderDesktop').removeClass('active');
  //     $('#searchHolderDesktop form input.search-field').blur()
  //     $('.topnav a, .topnav .pipe').each(function () {
  //         $(this).removeClass('hidden')
  //     })
  // }

  function closeAllDropDowns() {
    // console.log("closeAllDropdowns function");
    $("header").removeClass("active");
    $(".underlay").removeClass("active");
    $(dropdowns).each(function () {
      $(this).removeClass("open");
    });
  }

  // on resize, reset this wiewport width

  if (viewportWidth <= 1023) {
    // console.log("mobile view");

    //$("header .dropdown a").click(function(e){e.stopPropagation()})
    $("header .dropdown a").click(function (e) {
      e.stopPropagation();
      // console.log("click click");
      closeAllDropDowns();
      //$('header').addClass('active'); $('.underlay').addClass('active');
      $(this).parent().addClass("open");
    });
  } else {
    // $("header div.menu-item:not(.dropdown)").mouseenter(function () {
    //   closeAllDropDowns();
    // });
    $(document).scroll(function () {
      closeAllDropDowns();
    });
    $("header .dropdown a").click(function (e) {
      e.stopPropagation();
    });
    $("header div.dropdown").mouseenter(function () {
      closeAllDropDowns();
      $("header").addClass("active");
      $(".underlay").addClass("active");
      $(this).addClass("open");
    });
  }
});
